import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { addLog } from "../../utils/addLog";
import { generateBOQ } from "../Service";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { useTranslation } from "react-i18next";
import { dataAccessPermission } from "../../utils/dataAccessPermission";
import { signOut } from "../../utils/signOut";

const TooltipDialog = ({
  openPopup,
  onClose,
  value,
  onChange,
  onKeyDown,
  dialogStyle,
}) => {
  return (
    <Dialog
      open={openPopup}
      onClose={onClose}
      PaperProps={{
        style: dialogStyle,
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <TextField
          sx={{
            "& .MuiOutlinedInput-root": {
              borderColor: "white",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "white",
            },
          }}
          size="middle"
          variant="outlined"
          InputProps={{
            style: {
              borderRadius: "10px",
              backgroundColor: "#F0F0F0",
              paddingLeft: "15px",
              fontSize: "medium",
            },
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          fullWidth
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
      </DialogContent>
    </Dialog>
  );
};

const SearchMore = ({ initData, onSearchMore }) => {
  const [t, i18n] = useTranslation("global");

  const [openSearch, setOpenSearch] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (event) => {
    if (initData.length > 0) {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setOpenSearch(true);
    }
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter" && inputValue.length > 0) {
      event.preventDefault();
      await genBOQ(inputValue);
      addLog("BOQ", "Search more", null);

      // Clear data
      setInputValue("");
    }
  };
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const genBOQ = async (txt) => {
    setOpenSearch(false);
    setLoading(true);

    const role = dataAccessPermission("OWNER");

    let dataForm = {
      UserPrompt: txt,
      UserRole: role,
      maxSearchLoop: 2,
    };

    await generateBOQ(dataForm).then((res) => {
      if (res && res.status === 200) {
        onSearchMore(res.data); // OK
      } else if (res.status === 401) {
        signOut();
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.message,
        });
        console.log(`error boqList:`, res);
      }
      setLoading(false);
    });
  };

  const dialogStyle = {
    position: "absolute",
    top: clickPosition.y,
    left: isSmallScreen ? "50%" : clickPosition.x,
    transform: isSmallScreen
      ? "translate(-50%, -50%)"
      : "translate(-30%, -70%)",
  };

  return (
    <>
      <Box>
        <Button
          variant="text"
          style={{ textTransform: "none", fontSize: "16px" }}
          size="small"
          onClick={handleClick}
        >
          {t("genboq.button.searchmore")}
        </Button>
        <TooltipDialog
          openPopup={openSearch}
          onClose={() => setOpenSearch(false)}
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          dialogStyle={dialogStyle}
        />
      </Box>
      {loading ? (
        <Backdrop
          sx={(theme) => ({
            color: "#fff",
            zIndex: theme.zIndex.drawer + 1,
          })}
          open={loading}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <CircularProgress color="inherit" />
            <Typography variant="h6" sx={{ marginLeft: 2 }}>
              Generating...
            </Typography>
          </Box>
        </Backdrop>
      ) : (
        ""
      )}
    </>
  );
};

export default SearchMore;
